export default "<p>register works!</p>\n"